import { getImageAttributes } from '@notino/react-web-utils';
import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

export const getImagesAttributes = (
  images: (
    | NonNullable<
        NonNullable<
          GetCatalogProductViewQuery['productDetailByCatalogMasterId']
        >['variants'][number]['media']
      >['mainImage']
    | null
    | undefined
  )[],
  domain: string,
  sourceKey: string
) =>
  images.map((image) =>
    getImageAttributes(
      { src: image?.src ?? '', alt: image?.alt ?? '' },
      domain,
      sourceKey
    )
  );
